import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VirtualScrollComponent} from "./virtual-scroll.component";

@NgModule({
  declarations: [
    VirtualScrollComponent
  ],
  imports: [
    CommonModule,
  ],
  entryComponents: [],
  exports: [VirtualScrollComponent]
})
export class VirtualScrollModule {
  constructor() {}
  public static forRoot(config = {}): ModuleWithProviders {
    return {
      ngModule: VirtualScrollModule,
      providers: [
        {provide: 'vs-config', useValue: config},
      ],
    };
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/virtual-scroll/virtual-scroll.module.ts